<section>

  <!-- CLOSE BUTTON -->
  <button type="button" class="close-button m-2" mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h3 mat-dialog-title>{{title}}</h3>

  <mat-dialog-content class="mat-typography m-auto">

<!--
    <div class="mb-2">
      <mat-checkbox [(ngModel)]="checked" (click)="selectAll()" i18n>
        Označiť všetky
      </mat-checkbox>
    </div>
 -->

    <div *ngFor="let item of list">

      <mat-checkbox clas="m-2" [(ngModel)]="item.vybrany" (click)="checkboxClick($event)">
        {{item.kod}} - {{item.popis}}
      </mat-checkbox>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close i18n>Zrušiť</button>
    <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial
      i18n (click)="onConfirm()">Potvrdiť</button>
  </mat-dialog-actions>


</section>
